import { FaLeaf,  FaCreditCard, FaShoppingBasket } from 'react-icons/fa'

const InfoSection = () => {
  const features = [
    {
      icon: <FaLeaf className="text-red-600 text-4xl" />,
      title: 'BEST QUALITY PRODUCTS',
      desc: 'Smooth nicotine absorption, best taste & smell, natural essential oils.',
    },
    {
      icon: <FaShoppingBasket className="text-red-600 text-4xl" />,
      title: 'SHIPPING',
      desc: 'All purchases over 100,000 IQD are eligible for free shipping.',
    },
    {
      icon: <FaCreditCard className="text-red-600 text-4xl" />,
      title: 'CASH ON DELIVERY',
      desc: 'Pay in cash when your order is delivered.',
    },
  ]

  return (
    <section className="bg-gray-50 py-12">
      <div className="max-w-6xl mx-auto grid grid-cols-3 sm:grid-cols-1 md:grid-cols-3 gap-8 text-center px-6 items-stretch">
        {features.map((f, i) => (
          <div
            key={i}
            className="flex flex-col items-center h-full p-4 bg-white rounded-lg shadow"
          >
            <div className="flex items-center justify-center w-20 h-20 rounded-full border border-gray-300 mb-4">
              {f.icon}
            </div>
            <h3 className="font-bold text-lg mb-2">{f.title}</h3>
            <p className="text-gray-600">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default InfoSection
